<script lang="ts">
    import PositionTeaser from "./PositionTeaser.svelte"
    import NewsTeaser from "./NewsTeaser.svelte"
    import Teaserbox from "./Teaserbox.svelte"
    import Slider from "./Slider/Slider.svelte"
    import { apiBaseURL, leitbild, startTeaser } from "../config"
    import { i18n, sprache } from "../store"
    import LadeAnimation from "./LadeAnimation.svelte"
    import Slide2 from "./Slider/Slide2.svelte"
    import Slide3 from "./Slider/Slide3.svelte"
    import SeiteC from "./Seite.svelte"
    import { getSeiten } from "../api"

    let ladePositionen = true
    let ladeNews = true
    let ladeStandpunkte = true

    let positionen: Seite[] = []
    let news: Seite[] = []
    let standpunkte: Seite[] = []
    getSeiten($sprache, null, "position", 4).then((r: Seite[]) => {
        positionen = r
        ladePositionen = false
    })
    getSeiten($sprache, null, "news", 2, "list", null, "-meta.datum").then(
        (r: Seite[]) => {
            news = r
            ladeNews = false
        }
    )
    getSeiten(
        $sprache,
        null,
        "standpunkt",
        4,
        "list",
        null,
        "-meta.datum"
    ).then((r: Seite[]) => {
        standpunkte = r
        ladeStandpunkte = false
    })
</script>

<SeiteC pfad="{$sprache}" />

<section class="padding_small">
    <div class="container">
        <div class="headline">
            <h2>{$i18n("Aktuelles")}</h2>
            <a href="/{$sprache}/news" class="btn">{$i18n("alle Meldungen")}</a>
        </div>
        <div class="collection">
            {#if ladeNews}
                <LadeAnimation />
            {/if}
            {#each news as item}
                <NewsTeaser news="{item}" />
            {/each}
        </div>
    </div>
</section>

<section class="padding_small">
    <div class="container">
        <div class="collection">
            {#each startTeaser[$sprache] as t}
                <Teaserbox
                    bild="{t.bild}"
                    titel="{t.titel}"
                    text="{t.text}"
                    url="{t.url}"
                />
            {/each}
        </div>
    </div>
</section>
<section class="padding_small">
    <div class="container">
        <h2>
            {$i18n("Leitbild der Stiftung Familienunternehmen und Politik")}
        </h2>
        <Slide3 item="{leitbild[$sprache]}" />
    </div>
</section>
<section class="padding_small">
    <div class="container">
        <div class="headline">
            <h2>{$i18n("Positionen")}</h2>
            <a
                href="/{$sprache == 'de' ? 'de/positionen' : 'en/positions'}"
                class="btn">{$i18n("alle Positionen")}</a
            >
        </div>
        <div class="collection">
            {#if ladePositionen}
                <LadeAnimation />
            {/if}
            {#each positionen as position}
                <PositionTeaser position="{position}" />
            {/each}
        </div>
    </div>
</section>

{#if $sprache == "de"}
    <section>
        <div class="bg_bottom"></div>
        <div class="container">
            <div class="headline">
                <h2>{$i18n("Unternehmer-Standpunkte")}</h2>
                <a href="/de/unternehmer-standpunkte" class="btn"
                    >{$i18n("alle Standpunkte")}</a
                >
            </div>
            {#if ladeStandpunkte}
                <LadeAnimation />
            {:else}
                <Slider
                    arrows
                    slides="{standpunkte?.map((s) => ({
                        image:
                            apiBaseURL + '/seiten/' + s.id + '/' + s.bild?.src,
                        author: s.meta?.autor,
                        title: s.titel,
                        teasertext: s.teaserText,
                        link: '/' + s.pfad,
                    }))}"
                    effect="fade"
                    template="style2"
                    type="postslider1"
                />
            {/if}
        </div>
        <div class="cutbottom"></div>
    </section>
{/if}

<style lang="less">
    @import "../css/base.less";

    .collection :global {
        .flex();
        margin: -15px;
        flex-wrap: wrap;
        .post {
            padding: 15px;
            .flex();
            flex-direction: column;
            .item {
                flex-grow: 1;
            }
        }
    }
</style>
